$(document).ready(function () {
	/*-----------------------------------------------*/
	// Helper: update messageDialog content (keeps modal structure intact)
	function updateDialog(alert) {
		if (alert && typeof alert === "object") {
			$("#messageDialogTitle").html(alert.title || "");
			$("#messageDialogBody").html(alert.body || "");
			var $footer = $("#messageDialogFooter");
			if (alert.footer) {
				$footer.html(alert.footer).show();
			} else {
				$footer.empty().hide();
			}
		}
	}
	/*-----------------------------------------------*/
	// Checkbox "Địa chỉ khác"
	var otherAddr = $("#other_address");
	if (otherAddr.length) {
		if (otherAddr.is(":checked")) {
			$(".receiver-info-order").show();
		} else {
			$(".receiver-info-order").hide();
		}
	}
	$("#other_address").on("change", function () {
		if ($(this).is(":checked")) {
			$(".receiver-info-order").show("fast");
		} else {
			$(".receiver-info-order").hide("fast");
			var infos = ["fullname", "phone", "email", "address", "local", "district"];
			for (var i = 0; i < infos.length; i++) {
				$('input[name="receiv_' + infos[i] + '"]').val("");
			}
		}
	});
	/*-----------------------------------------------*/
	$(".checked span").click(function () {
		$(this).parents(".checked").find("label").click();
	});
	/*-----------------------------------------------*/
	// Checkout: ĐỒNG Ý ĐẶT HÀNG (trang xác nhận)
	$(".js-btn-finished").click(function () {
		updateDialog({ title: "Đang xử lý...", body: '<i class="fa fa-spinner fa-spin"></i> Vui lòng đợi' });
		$("#messageDialog").modal("show");
		$.post(
			this.href,
			function (rdata) {
				updateDialog(rdata.alert);
			},
			"json"
		);
		return false;
	});
	/*-----------------------------------------------*/
	// Add to cart
	$(".btn-addtocart").click(function () {
		var f = document.forms["form_addcart"];
		if (!f) return;
		var sdata = $(f).serializeArray();
		var cart_total = parseInt($(".js-cart-total").text()) + 1;
		$(".js-cart-total").text(cart_total);
		updateDialog({ title: "Đang xử lý...", body: '<i class="fa fa-spinner fa-spin"></i>' });
		$("#messageDialog").modal("show");
		$.post(
			f.action,
			sdata,
			function (rdata) {
				$(".js-cart-total").text(rdata.cart_qty);
				updateDialog(rdata.alert);
				$("#messageDialogBody .count").append(rdata.now_qty);
			},
			"json"
		);
	});
	/*-----------------------------------------------*/
	// Remove item from cart
	$(".js-remove-item").click(function () {
		$(this).parents("tr").fadeOut();
		var href = $(this).attr("href");
		var rel = $(this).attr("rel");
		$.post(
			href,
			{ key: rel },
			function (rdata) {
				$(".js-page-cart .js-grand-total").text(rdata.subtotal_price);
				$(".js-cart-total").text(rdata.total);
				if (rdata.total <= 0) {
					updateDialog(rdata.alert);
					$("#messageDialog").modal("show");
					$(".table").fadeOut("slow");
					$(".shop-grand-total").fadeOut("slow");
					$(".shop-button").fadeOut("slow");
				}
			},
			"json"
		);
		return false;
	});
	/*-----------------------------------------------*/
	// Update quantity
	$(".js-update-qty").click(function () {
		var input_qty = $(this).parents(".qty").find(".cart-qty");
		if ($(this).attr("rel") == "plus") {
			input_qty.val(parseInt(input_qty.val()) + 1);
		} else {
			var v = parseInt(input_qty.val()) - 1;
			if (v <= 0) v = 1;
			input_qty.val(v);
		}
		var cart_index = $(this).parents("tr").find("input[name='cart_index']").val();
		var car_qty = $(this).parents(".qty").find("input.cart-qty").val();
		$.post(
			$(this).attr("href"),
			{ key: cart_index, qty: car_qty },
			function (rdata) {
				$("#row_index_" + cart_index).find(".js-item-total").text(rdata.total_price);
				$(".js-page-cart .js-grand-total").text(rdata.subtotal_price);
				$(".js-cart-total").text(rdata.total);
			},
			"json"
		);
		return false;
	});
	/*-----------------------------------------------*/
	// Checkout button (trang thanh toán)
	$(".js-btn-checkout").click(function () {
		var f = document.forms["form_customer"];
		if (!f) return false;
		var error = false;
		var fields = $("#other_address").is(":checked") ? ".required, .receiv-required" : ".required";
		$(f).find(fields).each(function () {
			if (this.value == "") {
				var data_error = $(this).attr("data-error");
				$(this).parents(".has-feedback").addClass("has-error");
				$(this).parents(".has-feedback").find(".with-errors").text(data_error);
				error = true;
			} else {
				$(this).parents(".has-feedback").removeClass("has-error");
				$(this).parents(".has-feedback").find(".with-errors").text("");
			}
		});
		if (!error) {
			f.submit();
		}
		return false;
	});
});
